// extracted by mini-css-extract-plugin
export var content = "_p1-1";
export var divider = "_p1-0";